'use client';

export default function GlobalError({
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	return (
		<html lang="en">
			<body
				style={{
					backgroundColor: '#020202',
					color: '#f4f4f5',
					display: 'flex',
					minHeight: '100vh',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					fontFamily: 'monospace',
				}}
			>
				<h1 style={{ fontSize: '2rem', fontWeight: 300 }}>SYSTEM ERROR</h1>
				<p
					style={{
						marginTop: '1rem',
						color: '#666',
						fontSize: '0.75rem',
						textTransform: 'uppercase',
						letterSpacing: '0.1em',
					}}
				>
					Critical failure occurred
				</p>
				<button
					type="button"
					onClick={reset}
					style={{
						marginTop: '2rem',
						border: '1px solid #1a1a1c',
						background: 'transparent',
						color: '#f4f4f5',
						padding: '12px 24px',
						fontSize: '0.75rem',
						textTransform: 'uppercase',
						letterSpacing: '0.1em',
						cursor: 'pointer',
					}}
				>
					Try Again
				</button>
			</body>
		</html>
	);
}
